import { render, staticRenderFns } from "./MakeTransfer.vue?vue&type=template&id=271a1ec4"
import script from "./MakeTransfer.vue?vue&type=script&lang=js"
export * from "./MakeTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports